import React, { useEffect, useState } from 'react'
import Security from './EssentialComp/Security'
import { Button } from 'antd'
import MentorRequest from './EssentialComp/MentorRequest'
import Donation from './EssentialComp/Donation'
import { leagueEventStore } from 'state/league/leagueEvent'
import { useLeagueSettingStep } from 'api/league/LeagueCreation/leagueCreation'
import ButtonSpinner from 'components/global/ButtonSpinner'
import ConfirmationModal from './Modals/ConfirmationModal'

interface Step7Props {
  handleBack: () => void
}

const Step7: React.FC<Step7Props> = ({ handleBack }) => {
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  const {
    leagueData,
    setLeagueData,
    riskLevel,
    setRiskLevel,
    donationData,
    setDonationData,
  } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
    riskLevel: store.riskLevel,
    setRiskLevel: store.setRiskLevel,
    donationData: store.donationData,
    setDonationData: store.setDonationData,
  }))

  const {
    mutate: leagueSettingMutation,
    isLoading: leagueSettingMutationLoading,
  } = useLeagueSettingStep()

  const handleSubmit = () => {
    const payload = {
      security: riskLevel,
      allowDonation: donationData.allowDonation,
      preSelectedDonationAmounts: donationData.preSelectedDonationAmounts,
    }

    leagueSettingMutation(
      { leagueId: leagueData._id, payload },
      {
        onSuccess: data => {
          setLeagueData({ ...leagueData, ...data })
          setConfirmModal(true)
        },
      },
    )
  }

  useEffect(() => {
    setRiskLevel(leagueData.security)
    setDonationData({
      allowDonation: leagueData.allowDonation,
      preSelectedDonationAmounts: leagueData.preSelectedDonationAmounts,
    })
  }, [])

  return (
    <>
      <div>
        <div
          className="scroller scroller-lg overflow-auto-y"
          style={{ height: `calc(100vh - 360px)` }}
        >
          <div className="mt-20px">
            <Security />
          </div>
          <div className="mt-20px">
            <MentorRequest />
          </div>
          <div className="mt-20px">
            <Donation />
          </div>
        </div>

        <div className="flex align-center justify-between mb-26 mt-40px">
          <Button
            className="cancel-button flex align-center justify-center gap-10px"
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            className="stepper-button"
            onClick={handleSubmit}
            disabled={leagueSettingMutationLoading}
          >
            {leagueSettingMutationLoading ? (
              <ButtonSpinner size={20} color="#000" />
            ) : (
              'Next'
            )}
          </Button>
        </div>
      </div>
      {confirmModal && (
        <ConfirmationModal
          openModal={confirmModal}
          setopenModal={setConfirmModal}
        />
      )}
    </>
  )
}

export default Step7
